import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { ConfigService } from './_core/service/config.service';
import { authInterceptor } from './_core/service/http-interceptor.service';
import { routes } from './app.routes';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import { RequestService } from './_services/request/request.service';
import { MaintenanceService } from './_services/maintenance/maintenance.service';
import { Router } from '@angular/router';

export function configInitializer(configService: ConfigService) {
  return () => configService.loadConfig();
}

export function requestInitializer(
  configService: ConfigService,
  maintenanceService: MaintenanceService,
  requestService: RequestService,
  router: Router,
) {
  return () => {
    // Skip initialization for 404 page
    if (window.location.pathname.includes('/404')) {
      return Promise.resolve();
    }

    return configService
      .loadConfig()
      .then(() => {
        // Check maintenance status after config is loaded
        return maintenanceService.checkMaintenance().toPromise();
      })
      .then((maintenanceResponse) => {
        const isMaintenanceMode = maintenanceResponse?.maintenanceFlag || false;
        maintenanceService.setMaintenanceMode(isMaintenanceMode);

        if (isMaintenanceMode) {
          // If maintenance mode is active, navigate to maintenance page
          router.navigate(['/maintenance']);
          return Promise.resolve();
        } else {
          // If not in maintenance mode, proceed with normal request flow
          return requestService
            .getRequestDetails()
            .toPromise()
            .then(() => {
              return Promise.resolve();
            });
        }
      })
      .catch((err) => {
        console.error('Failed to load request details:', err);
        window.location.href = '/404';
        return Promise.resolve();
      });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      useFactory: configInitializer,
      deps: [ConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: requestInitializer,
      deps: [ConfigService, MaintenanceService, RequestService, Router],
      multi: true,
    },
    provideHttpClient(withInterceptors([authInterceptor])),
    provideEnvironmentNgxMask(),
  ],
};
